import MoreCandidate from 'components/jobDescription/MoreCandidate';
import { CandidateSubmissionType } from 'components/JobQueue/utils';
import { Loader } from 'components/loader';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { addNewData, getAllListData } from 'services/CommonServices';
import { MASTER_ENDPOINT, SALES_ENDPOINT } from 'utils/Constant';

import JobDescription from '../../../components/jobDescription/JobDescription';
import MatchesAndShortlist from '../../../components/jobDescription/MatchesAndShortlist';

// interface Candidate {
//   id: string;
//   matchPercentage: number;
//   visaStatus: string;
//   source: string;
//   name: string;
//   availability: string;
//   availabilityDate: string;
//   email: string;
//   phone: string;
//   location: string;
//   isSelected: boolean;
//   topSkills?: string;
// }

const JobDescriptionPage: React.FC = () => {
  const { jobId } = useParams();
  const [matches, setMatches] = useState<CandidateSubmissionType[]>();
  const [shortlisted, setShortlisted] = useState<CandidateSubmissionType[]>([]);
  const [jobData, setJobData] = useState<any>({});
  const [loader, setLoader] = useState<boolean>(true);
  const [activeTab, setActiveTab] = useState(0);
  const [more, setMore] = useState<boolean>(false);

  const handleSelectCandidate = (candidateId: string, selected: boolean) => {
    // In Shortlisted tab: toggle selection only
    setShortlisted((prev: any[]) =>
      prev.map((c: any) =>
        c.id === candidateId ? { ...c, selectedForSubmit: selected } : c,
      ),
    );
  };

  const handleExpandCandidate = (candidateId: string) => {
    // Handle candidate expansion
    console.log('Expand candidate:', candidateId);
  };
  const getMatchedCandidates = async (id: string) => {
    // setLoader(true);
    await getAllListData(
      `${SALES_ENDPOINT.MatchedCandidates}/${id}?type=${
        activeTab === 0 ? 'matched' : 'shortlisted'
      }`,
    )
      .then((res) => {
        setMatches(res?.data || []);
        // setMatches(SampleData);
        // setLoader(false);
      })
      .catch((err: any) => {})
      .finally(() => {});
  };
  const getJobData = async (id: string) => {
    setLoader(true);
    await getAllListData(`${MASTER_ENDPOINT.Jobs}?id=${id}`)
      .then((res) => {
        setJobData(res?.data?.[0]);
        // if (res?.data?.[0]?.jobSkills) {
        //   let sName = '';
        //   let primarySkill = '';
        //   res?.data?.[0]?.jobSkills.map((item: any) => {
        //     sName += item.skill.name + ',';
        //     primarySkill += item.skill.primary ? item.skill.name + ',' : '';
        //   });
        //   if (sName) {
        //     sName = sName.replace(/,\s*$/, '');
        //   }
        //   if (primarySkill) {
        //     primarySkill = primarySkill.replace(/,\s*$/, '');
        //   }

        //   setParam({
        //     ...staticParam,
        //     primarySkill,
        //     skillName: sName,
        //   });
        // }
        setLoader(false);
      })
      .catch((err: any) => {})
      .finally(() => {
        setLoader(false);
      });
  };

  React.useEffect(() => {
    getJobData(jobId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobId]);

  React.useEffect(() => {
    getMatchedCandidates(jobId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const handleConfirmSubmit = async (selected: CandidateSubmissionType[]) => {
    const payload: any = {
      candidateIds: selected.map((c: any) => c?.candidate?.id || c.id),
      jobPostingId: jobId,
    };
    await addNewData(
      payload,
      `${SALES_ENDPOINT.MatchedCandidates}/submit`,
      {},
      true,
    );
  };

  return (
    <div
      style={{
        backgroundColor: '#ffffff',
      }}>
      {loader ? (
        <Loader newLoader />
      ) : more ? (
        <MoreCandidate goBack={() => setMore(false)} matchesList={matches} />
      ) : (
        <div
          style={{
            display: 'flex',
          }}>
          {/* Left Side - Job Description */}
          <div
            style={{
              borderRight: '1px solid #e5e7eb',
              flex: '1',
            }}>
            <JobDescription
              jobData={jobData}
              jobSummary={jobData?.jobDescription}
            />
          </div>
          {/* Right Side - Matches and Shortlist */}
          <div
            style={{
              flex: '1',
            }}>
            <MatchesAndShortlist
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              matches={matches}
              shortlisted={shortlisted}
              onSelectCandidate={handleSelectCandidate}
              onExpandCandidate={handleExpandCandidate}
              onConfirmSubmit={handleConfirmSubmit}
              setMore={() => setMore(true)}
              jobId={jobId}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default JobDescriptionPage;
